import { $qs } from 'fxdom/es';

export const show = () => {
  $qs('#maker_frame .maker_menu').dataset.down_list_show = 'true';
};
export const hide = () => {
  $qs('#maker_frame .maker_menu').dataset.down_list_show = 'false';
};
